var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-icon',{class:_vm.classIcon,style:(_vm.styleIcon)})
}
var staticRenderFns = []

export { render, staticRenderFns }